export const howItWorkItems = [
  {
    title: 'Согласовываете условия сотрудничества',
    descr: 'Партнер заполняет реквизиты и подписывает договор о сотрудничестве',
  },
  {
    title: 'Получаете промокоды для реализации',
    descr: 'Мы выдаем промокоды для распространения среди клиентов партнера',
  },
  {
    title: 'Продвигаете KION среди своих клиентов',
    descr: 'Клиент подключает подписку с использованием промокода партнера',
  },
  {
    title: 'Ваш клиент становится зрителем KION',
    descr: 'Клиенту становится доступен полный видеоконтент онлайн-кинотеатра',
  },
  {
    title: 'Получаете заработанное вознаграждение',
    descr:
      'За каждого активного подписчика мы готовы честно делиться с партнером',
  },
]
